import http from "../http";
import env from "../config/loadEnv";

export async function fetchGet(endpoint, params = {}) {
    const url = `${env.baseURL}${endpoint}`;
    return await http.get(url, {
        params
    })
        .then(response => {
            return {
                status: true,
                data: response.data
            };
        })
        .catch(e => {
            console.error(`Fetch get ${endpoint}: `, e );
            return {
                status: false,
                data: []
            };
        })
}

export async function fetchPost(endpoint, data) {
    const url = `${env.baseURL}${endpoint}`;
    return await http.post(url, data)
        .then(response => {
            return {
                status: true,
                data: response.data
            };
        })
        .catch(e => {
            console.error(`Fetch post ${endpoint}: `, e );
            return {
                status: false,
                data: []
            };
        })
}



// WEBPACK FOOTER //
// ./src/composables/api.js